let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a0k8L")).then(() => parcelRequire('h11eg'));